import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

function LanguageMiddleware({ children, location, history }) {
    useEffect(() => {
        const ensureLangParam = () => {
            const urlParams = new URLSearchParams(location.search);
            const currentLang = urlParams.get('lang');
            const preferredLang = localStorage.getItem('preferredLanguage') || getDefaultLanguage();
            const lang = currentLang || preferredLang;

            // If lang is not in the URL, add it while preserving other query parameters
            if (!currentLang) {
                urlParams.set('lang', lang);
                const newUrl = `${location.pathname}?${urlParams.toString()}`;
                // Only replace the URL if the lang param is missing
                if (location.search !== `?${urlParams.toString()}`) {
                    history.replace(newUrl);
                }
            }
        };

        // Check the language param when the component mounts
        ensureLangParam();

        // Listen for history changes (back/forward navigation)
        const handlePopState = () => {
            ensureLangParam();
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [location, history]);

    return <>{children}</>;
}

const getDefaultLanguage = () => {
    const browserLang = navigator.language || navigator.userLanguage || 'en';
    return browserLang.split('-')[0] || 'en';
};

export default withRouter(LanguageMiddleware);
